import {IView} from "../stores/InterfaceStore";
import {useStores} from "../stores/useStores";

export const useIsCollectionPage = () => {
    const {interfaceStore} = useStores();

    return interfaceStore.view === IView.MAP || interfaceStore.view === IView.ALPHA;
}
